import { RefObject } from "react";
import { mapIframeUrl } from "src/config";

/**
 * URL of the embedded Ex-Act map. Selected by environment via
 * REACT_APP_MAP_URL_PROD / REACT_APP_MAP_URL_DEV (see src/config).
 */
export const MAP_URL = mapIframeUrl;

const MapIframe = ({ iframeRef, width }: { iframeRef: RefObject<HTMLIFrameElement>, width?: string }) => {
  return (
    <div className="map-iframe-container">
      <iframe
        ref={iframeRef}
        src={MAP_URL}
        style={{
          width: width || '750px',
          border: 'none',
          aspectRatio: '1',
        }}
        title="FAO Ex-Act Map"
        allowFullScreen
      />
    </div>
  );
};

export default MapIframe;